export default "__VITE_ASSET__cce93087__"